module.exports = __webpack_public_path__ + "img/76.e4b9cd28.png";